// extracted by mini-css-extract-plugin
module.exports = {"productDescription":"KeySpec_productDescription__3qYcJ","description":"KeySpec_description__35-ii","productDisclaimer":"KeySpec_productDisclaimer__V8W9a"};